import Features from "../components/Features";
import Workflow from "../components/Workflow";
import ProductShowcase from "../components/ProductShowcase";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

function PlatformPage() {
  return (
    <>
      <SEO
        title="Platform | KMC Health (Kitmeechai Health)"
        description="A modern digital healthcare platform enabling secure online medical consultation, e-prescription, medical records, and corporate health services."
        path="/platform"
      />
      <Features />
      <Workflow />
      <ProductShowcase />
      <Footer />
    </>
  );
}

export default PlatformPage;